module.exports = __webpack_public_path__ + "static/media/42 - Oliver Cheatham - Get Down Saturday Night.c87f8d88.mp3";